import * as React from 'react';

import {
  Button,
  FormElement,
  Grid,
  Input,
  Modal,
  Text,
} from '@nextui-org/react';
import { DateTime } from 'luxon';

export interface DateRangeSelect {
  endDate: Date;
  startDate: Date;
}

interface ModalDateRangeSelectProps {
  onCancel: () => void;
  onOk: (dateRange: DateRangeSelect) => void;
  selected: DateRangeSelect;
  visible: boolean;
}

/**
 * @name ModalDateRangeSelect
 * @description tbd...
 */
export function ModalDateRangeSelect(props: ModalDateRangeSelectProps) {
  const { onCancel, onOk, selected, visible } = props;

  // Hooks
  const [startDate, setStartDate] = React.useState(selected.startDate);
  const [endDate, setEndDate] = React.useState(selected.endDate);

  // Handlers
  const onStartChange = (e: React.ChangeEvent<FormElement>) => {
    setStartDate(new Date(e.target.value.trim()));
  };

  const onEndChange = (e: React.ChangeEvent<FormElement>) => {
    setEndDate(new Date(e.target.value.trim()));
  };

  return (
    <Modal
      blur
      preventClose
      aria-labelledby="modal-title"
      open={visible}
      onClose={() => onCancel()}
    >
      <Modal.Header>
        <Text id="modal-title" size={18} b>
          Select Date Range
        </Text>
      </Modal.Header>
      <Modal.Body>
        <Grid.Container gap={2}>
          <Grid xs={6}>
            <Input
              fullWidth={true}
              label="Start Date"
              type="date"
              value={DateTime.fromJSDate(startDate).toFormat('yyyy-MM-dd')}
              onChange={onStartChange}
            />
          </Grid>
          <Grid xs={6}>
            <Input
              fullWidth={true}
              label="End Date"
              type="date"
              value={DateTime.fromJSDate(endDate).toFormat('yyyy-MM-dd')}
              onChange={onEndChange}
            />
          </Grid>
        </Grid.Container>
        <Grid.Container gap={2}>
          <Grid xs={6}>
            <Button
              auto
              css={{ w: 'stretch' }}
              flat
              onPress={() => {
                setStartDate(DateTime.now().startOf('month').toJSDate());
                setEndDate(DateTime.now().endOf('month').toJSDate());
              }}
            >
              This Month
            </Button>
          </Grid>
          <Grid xs={6}>
            <Button
              auto
              css={{ w: 'stretch' }}
              flat
              onPress={() => {
                const { end, start } = previousMonth();
                setStartDate(start.toJSDate());
                setEndDate(end.toJSDate());
              }}
            >
              Last Month
            </Button>
          </Grid>
        </Grid.Container>
      </Modal.Body>
      <Modal.Footer>
        <Grid.Container gap={1}>
          <Grid xs={6} justify="center">
            <Button
              auto
              light
              color="error"
              css={{ w: 'stretch' }}
              onPress={onCancel}
            >
              Cancel
            </Button>
          </Grid>
          <Grid xs={6} justify="center">
            <Button
              auto
              css={{ w: 'stretch' }}
              onPress={() => onOk({ endDate, startDate })}
            >
              Ok
            </Button>
          </Grid>
        </Grid.Container>
      </Modal.Footer>
    </Modal>
  );
}

/**
 * @name previousMonth
 * @description Returns the start and end dates of the previous month.
 */
function previousMonth() {
  const now = DateTime.now();
  const lastMonth = now.minus({ month: 1 });
  const month = lastMonth.get('month');
  const year = lastMonth.get('year');
  const start = DateTime.fromObject({ month, year }).startOf('month');
  const end = DateTime.fromObject({ month, year }).endOf('month');

  return { end, start };
}
